<template>
	<div class="goods meeting">
       <v-head :title="title"></v-head>		
	   <div>
			<van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
			    <van-swipe-item>
                        <img :src="this.photoId" v-if="this.photoId"/>
<!--						<img src="../../assets/images/yuansu.jpg" v-else>-->
                    </van-swipe-item>
            <!-- <van-swipe-item>2</van-swipe-item>
            <van-swipe-item>3</van-swipe-item>
            <van-swipe-item>4</van-swipe-item> -->
			</van-swipe>
		</div>
		<div class="titDiv">
			<h4>{{meeting.name}}</h4>
			<div>
				<span>举办时间：{{meeting.startDate | limitDate}}</span>
				<span style="float:right">举办地点：{{meeting.provinceName}}</span>
			</div>
			<p>会议报名和论文投稿截止日期：{{meeting.registerEndDate | limitDate}}</p>
			<p>酒店预定截止日期：{{meeting.deliveryEndDate | limitDate}}</p>
			<p>网上缴费截止日期：{{meeting.payStartDate | limitDate}}</p>
		</div>
		<div style="padding:0 20px; margin:20px 0">
			<van-button type="info" block style="margin-top:20px" @click="goPath">立即报名</van-button>
		</div>
		<!-- <div class="tabCent">
				<van-tabs>
					<van-tab title="大会简介">
						<div class="boxDivCent boxcer">
							中国共产党第十八次全国代表大会(简称中共十八大)于2012年11月8日在北京召开。中央确定，党的十八大代表名额共2270名，由全国40个选举单位选举产生。2012年11月8日9:00在人民大会堂大礼堂举行。大会选举了新一届的中共中央领导层，包括中央委员会委员、
							中央候补委员、中央纪律检查委员会委员。在之后召开的中央委员会上选举中央委员会总书记、中央政治局、中央政治局常务委员会、中央书记处、中共中央军委等。
							2012年11月14日12时许，在人民大会堂胜利闭幕。大会的秘书长为习近平 ，副秘书长为刘云山、李源潮、栗战书 。
						</div>
					</van-tab>
					<van-tab title="特邀报告"><div class="boxDivCent boxcer">内容 1</div></van-tab>
					<van-tab title="分会场">
						<div class="boxDivCent">
							<box1></box1>
						</div>
					</van-tab>
					<van-tab title="大会日程"><div class="boxDivCent boxcer">内容 1</div></van-tab>
					<van-tab title="会议通知"><div class="boxDivCent boxcer">内容 1</div></van-tab>
				</van-tabs>
		</div> -->


	  <vNavbar :active="navActive"  @on_chang_active="changActive"></vNavbar>
	</div>
</template>

<script>
import vHead from "../../components/Subhead.vue";
import vNavbar from "../../components/navbar.vue";
import box1 from "../MeetingCenter/newMeeting/fhc.vue";
import {Icon,Row, Col,Button,Tab, Tabs,Swipe,SwipeItem,DropdownMenu,DropdownItem,Loading,Divider } from 'vant';
import { mapGetters, mapState,mapActions} from "vuex";
import { getMeetingDetail,getPZUrl} from "@/api/dictionary";
import {getSessionStore} from "@/utils/sessionStorage.js"
export default {
  
  data() {
    return {
		// active: 1,
		navActive:2,
		loading: false,
		type: "starting",
		page: 0,
		list: [],
		userInfo:{},
		title:"会议详情",
		meeting:{},
		photoId:''
    };
  },
  components: {
	  vHead,
	  vNavbar,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
	[Swipe.name]:Swipe,
	[SwipeItem.name]:SwipeItem,
	[Divider.name]:Divider,
	[Tab.name]:Tab,
	[Tabs.name]:Tabs,
	box1,
  },
	watch: {
		type(val) {
			this.page = 0;
			this.getDate()
		}
	},
  methods: {
  	...mapActions(["getGroupMemberType", "getPersonMemberType"]),
	  goPath() {
	    this.$router.push({ name: 'signUpMeeting',query:{meetingId:this.id} });
	  },
	  changActive(val){
		  this.navActive = val;
	  },
	  meetingDetails(){
		  getMeetingDetail({meetingId:this.id}).then(res=>{
			  if(res.success){
				  this.meeting = res.result.meetingDTO;

				  if(this.meeting.photoId){
                    let params = {id:this.meeting.photoId}
                    getPZUrl(params).then(res => {
                        this.photoId = res.result;
                    });
                  }

			  }
		  })
	  }
  },
  	computed:{
		...mapGetters([ "getMemberType"]),
		id() {
	      return this.$route.query && this.$route.query.meetingId;
	    }
	},
	mounted() {
		this.meetingDetails();
		//this.getPersonMemberType();
	}
};
</script>


<style lang="less" scoped>
.meeting /deep/.van-nav-bar__title, .meeting /deep/.van-nav-bar__text{ color: #000 !important;}
.meeting /deep/.sign_out{ color: #000 !important;}

 .my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
	line-height: 150px;
	height: 5rem;
    text-align: center;
    background-color: #39a9ed;
  }
.titDiv{ font-size:14px; border-top: #eee solid 8px; border-bottom:#eee solid 8px;padding:30px 20px; line-height: 30px;}
.titDiv h4{ font-size: 20px; font-weight: bold; margin-bottom: 10px;}
.tabCent{ margin-bottom: 75px; font-size: 14px;}
.boxDivCent{  line-height:28px;}
.tabCent /deep/.van-tabs__line{ background-color: #1989fa;}
.tabCent /deep/.van-tab__text--ellipsis{padding-top: 10px;}
.boxcer{ padding: 20px;}
.my-swipe .van-swipe-item img{ width: 100%; height: 5rem;}
</style>
